import { NavLink, useLocation } from "react-router-dom";
import { 
  DollarSign, 
  LayoutDashboard, 
  FileText, 
  Users, 
  Clock, 
  AlertTriangle,
  BarChart3,
  Settings,
  HelpCircle,
  ShieldCheck,
  Database,
  UserCog,
} from "lucide-react";
import { cn } from "@/lib/utils";
import { ROUTES } from "@/routes";

const navItems = [
  { icon: LayoutDashboard, label: "Dashboard", path: ROUTES.BILLING },
  { icon: FileText, label: "Claims", path: ROUTES.BILLING_CLAIMS },
  { icon: Clock, label: "A/R Aging", path: ROUTES.BILLING_AGING },
  { icon: AlertTriangle, label: "Denials", path: ROUTES.BILLING_DENIALS },
  { icon: Users, label: "Payers", path: ROUTES.BILLING_PAYERS },
  { icon: BarChart3, label: "Reports", path: ROUTES.BILLING_REPORTS },
  { icon: ShieldCheck, label: "Compliance", path: ROUTES.BILLING_COMPLIANCE },
  { icon: Database, label: "Providers", path: ROUTES.BILLING_PROVIDERS },
  { icon: UserCog, label: "Assignments", path: ROUTES.BILLING_ASSIGNMENTS },
];

const bottomNavItems = [
  { icon: Settings, label: "Settings", path: ROUTES.BILLING_SETTINGS },
  { icon: HelpCircle, label: "Help", path: ROUTES.BILLING_HELP },
];

export default function BillingSidebar() {
  const location = useLocation();

  return (
    <aside className="w-64 bg-card border-r border-border flex flex-col h-screen sticky top-0">
      {/* Logo */}
      <div className="p-6 border-b border-border">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-success to-primary shadow-md">
            <DollarSign className="h-5 w-5 text-success-foreground" />
          </div>
          <div>
            <h1 className="font-display font-bold text-foreground">Vivien RCM</h1>
            <p className="text-xs text-muted-foreground">Revenue Cycle</p>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="flex-1 p-4 space-y-1">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={cn(
                "flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors",
                isActive
                  ? "bg-success/10 text-success"
                  : "text-muted-foreground hover:bg-muted hover:text-foreground"
              )}
            >
              <item.icon className="h-5 w-5" />
              {item.label}
            </NavLink>
          );
        })}
      </nav>

      {/* Bottom Navigation */}
      <div className="p-4 border-t border-border space-y-1">
        {bottomNavItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={cn(
                "flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors",
                isActive
                  ? "bg-success/10 text-success"
                  : "text-muted-foreground hover:bg-muted hover:text-foreground"
              )}
            >
              <item.icon className="h-5 w-5" />
              {item.label}
            </NavLink>
          );
        })}
      </div>
    </aside>
  );
}
